module.exports = __webpack_public_path__ + "./eddie-illustration_0dc822e603c62dfdae4fb2c83bf4094c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2014/eddie-illustration.png
// module id = 410
// module chunks = 0